import React from "react";
import ErrorBanner from "src/components/Form/ErrorBanner";
import FormContext from "src/context/FormContext";

export const AlertBannerSection = () => {
  const { displayingAlertBanner, setDisplayingAlertBanner } =
    React.useContext(FormContext);

  return (
    <ErrorBanner
      errorType={displayingAlertBanner}
      onClose={setDisplayingAlertBanner}
      alertBannerProps={{
        fluidity: false,
      }}
    />
  );
};
